import React from 'react'
import { WithTooltip } from '../../design-system'
import { css } from '@emotion/css'
import { theme as deprecatedTheme } from '../../styled/theme'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { SpiderBotIcon } from '../../legacy-design-system/icons'

const iconSize = 20

type BrowserType = 'chrome' | 'ie' | 'firefox' | 'opera' | 'safari'

const browserTypes: BrowserType[] = [
  'chrome',
  'ie',
  'firefox',
  'opera',
  'safari'
]

type BrowserIcons = Record<BrowserType, React.ReactNode>

function BrowserImage({ resourceName }: { readonly resourceName: string }) {
  return <img height={iconSize} src={`images/live/${resourceName}.png`} />
}

const browserIcons: BrowserIcons = {
  chrome: <BrowserImage resourceName="chrome" />,
  firefox: <BrowserImage resourceName="firefox" />,
  ie: <BrowserImage resourceName="ie" />,
  opera: <BrowserImage resourceName="opera" />,
  safari: <BrowserImage resourceName="safari" />
}

interface BrowserItemProps {
  readonly name: BrowserType | string
  readonly version: string
}

export function BrowserItem({ name, version }: BrowserItemProps) {
  return (
    <div
      className={css`
        justify-content: center;
        display: flex;
        width: fit-content;
      `}
    >
      <WithTooltip
        placement="right"
        renderTooltipContent={() => {
          return <BrowserTooltipContent name={name} version={version} />
        }}
        children={() => (
          <div
            className={css`
              display: flex;
              align-items: center;
            `}
          >
            {!!browserTypes.find(
              (browserType) => browserType === (name as BrowserType)
            ) ? (
              browserIcons[name]
            ) : (
              <SpiderBotIcon size={iconSize} color={theme.color.white} />
            )}
          </div>
        )}
      />
    </div>
  )
}

interface BrowserTooltipContentProps {
  readonly name: string
  readonly version: string
}

export function BrowserTooltipContent({
  name,
  version
}: BrowserTooltipContentProps) {
  return (
    <div
      className={css`
        display: flex;
        flex-direction: column;
      `}
    >
      <div
        className={css`
          display: flex;
          font-size: 14px;
          font-weight: ${deprecatedTheme.fontWeights.primary.bold};
        `}
      >
        {name}
      </div>
      <div
        className={css`
          display: flex;
          font-size: 14px;
          margin-bottom: 8px;
        `}
      >
        {version}
      </div>
    </div>
  )
}
